import type { SaleDetail } from '../../sales/domain/salesTypes';

const MP_QR_TERMINAL_PAYMENT_STATUSES = new Set(['cancelled', 'failed', 'expired']);

function getMercadoPagoQrPayment(detail: SaleDetail | null | undefined) {
  return detail?.payments.find((p) => p.methodId === 'mercadopago_qr') ?? null;
}

function mpQrSaleMissingOperationNumber(detail: SaleDetail | null | undefined): boolean {
  const mpPayment = getMercadoPagoQrPayment(detail);
  if (!mpPayment?.metadata) return false;
  const meta = mpPayment.metadata;
  const hasOp =
    Boolean(String(meta.mpOperationNumber ?? '').trim()) ||
    /^\d+$/.test(String(meta.reference_id ?? '').trim());
  if (hasOp) return false;
  return Boolean(String(meta.orderId ?? '').trim());
}

/** Backfill de nº operación: solo ventas activas con cobro MP confirmado/pagado. */
export function shouldBackfillMpQrOperationNumber(detail: SaleDetail | null | undefined): boolean {
  if (!detail || detail.status === 'voided') return false;
  if (!mpQrSaleMissingOperationNumber(detail)) return false;

  const mpPayment = getMercadoPagoQrPayment(detail);
  if (!mpPayment) return false;
  if (MP_QR_TERMINAL_PAYMENT_STATUSES.has(mpPayment.status)) return false;

  return detail.paymentStatus === 'paid' || mpPayment.status === 'confirmed';
}
